let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jU0pu")).then(() => parcelRequire('2VMh0'));